const notifications = {
  verifiedEmail: "Thank you for verifying your email. Your account setup is complete."
};

export default notifications;
